import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import Axios from "../../Axios";

import "./courseList.scss";

const noFile = require("../../assets/no-file.png");
const noIMG = require("../../assets/no-image.png");
const headerLogo = require("../../assets/logo-white.png");

const stripHtml = (html = "") => {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

const formatLessons = (item) => {
  if (item?.lesson_count !== null && item?.lesson_count !== undefined) {
    return `${item.lesson_count} хичээл`;
  }
  return "0 хичээл";
};

const formatDuration = (item) => {
  if (item?.duration !== null && item?.duration !== undefined) {
    const hours = Math.floor(item.duration / 60);
    const minutes = item.duration % 60;

    if (hours > 0 && minutes > 0) {
      return `${hours} цаг ${minutes} минут`;
    }
    if (hours > 0) {
      return `${hours}цаг`;
    }
    return `${minutes}минут`;
  }

  return "0 минут";
};

const formatStudents = (item) => {
  if (item?.students) return item.students;
  if (item?.enrolled) return item.enrolled;
  return "1.2k+";
};

const getAuthorName = (item) => {
  return (
    item?.teacher ||
    item?.author ||
    item?.user?.name ||
    item?.createdBy ||
    "Баярсайхан Пүрэв-Очир"
  );
};

const CourseList = ({ title = "Хичээлүүд", type, inUserCourses = false }) => {
  const { authConfig } = useAuthContext();

  const [data, setData] = useState([]);
  const [sortType, setSortType] = useState("all");

  const getAllCourses = useCallback(() => {
    let typeID = 0;

    if (type === "free") {
      typeID = 1;
    }

    Axios.get(`/courses/${typeID}/list`).then((res) => {
      if (res.status === 200) {
        setData(Array.isArray(res.data) ? res.data : []);
      }
    });
  }, [type]);

  const getUserCourses = useCallback(() => {
    Axios.get("/users_courses/user", authConfig).then((res) => {
      if (res.status === 200) {
        setData(Array.isArray(res.data) ? res.data : []);
      }
    });
  }, [authConfig]);

  useEffect(() => {
    if (inUserCourses) {
      getUserCourses();
    } else {
      getAllCourses();
    }
  }, [inUserCourses, getUserCourses, getAllCourses]);

  const sortedData = useMemo(() => {
    const cloned = [...data];

    switch (sortType) {
      case "name_asc":
        return cloned.sort((a, b) =>
          String(a?.title || "").localeCompare(String(b?.title || "")),
        );
      case "name_desc":
        return cloned.sort((a, b) =>
          String(b?.title || "").localeCompare(String(a?.title || "")),
        );
      default:
        return cloned;
    }
  }, [data, sortType]);

  const pageTypeText = type === "free" ? "Анхан шатны үнэгүй" : "Ахисан шатны";

  const badgeText = type === "free" ? "Үнэгүй" : "Төлбөртэй";

  return (
    <section className="courseList">
      <div className="courseList__layout">
        {!inUserCourses && (
          <aside className="courseSidebar">
            <div className="courseSidebar__brand">
              <div className="courseSidebar__logo">
                <img src={headerLogo} alt="Ochiroo's Theory" />
              </div>
            </div>

            <div className="courseSidebar__menu">
              {/* <button type="button" className="courseSidebar__item">
                <span className="courseSidebar__icon">◫</span>
                <span>Нүүр</span>
              </button> */}

              <button
                type="button"
                className="courseSidebar__item courseSidebar__item--active"
              >
                <span className="courseSidebar__icon">▣</span>
                <span>{pageTypeText}</span>
              </button>

              <button type="button" className="courseSidebar__item">
                <span className="courseSidebar__icon">▤</span>
                <span>Бүх сургалтууд</span>
              </button>

              {/* <button type="button" className="courseSidebar__item">
                <span className="courseSidebar__icon">◧</span>
                <span>Миний сургалтууд</span>
              </button> */}
            </div>

            <div className="courseSidebar__profile">
              <div className="courseSidebar__avatar">O</div>
              <div className="courseSidebar__profileText">
                <strong>Ochiroo</strong>
                <p>ochiroo@email.com</p>
              </div>
            </div>
          </aside>
        )}

        <div className="courseMain">
          {!inUserCourses && (
            <div className="courseTopBanner">
              <div className="courseTopBanner__left">
                <h1>{title}</h1>
                <p>
                  Өөрт тохирсон хичээлээ сонгоод шат дараатайгаар суралцаарай.
                </p>
              </div>

              <div className="courseTopBanner__right">
                <label htmlFor="course-sort">Эрэмбэлэх</label>
                <select
                  id="course-sort"
                  value={sortType}
                  onChange={(e) => setSortType(e.target.value)}
                >
                  <option value="all">Нийт</option>
                  <option value="name_asc">Нэр A-Я</option>
                  <option value="name_desc">Нэр Я-A</option>
                </select>
              </div>
            </div>
          )}

          <div className="courseBoard">
            {sortedData.length === 0 ? (
              <div className="courseList__empty">
                <div className="courseList__empty-icon">📘</div>
                <h3>Сургалтын мэдээлэл олдсонгүй</h3>
                <p>Одоогоор энэ төрлийн сургалт бүртгэгдээгүй байна.</p>
              </div>
            ) : (
              <div className="courseList__grid">
                {sortedData.map((item) => {
                  const plainDescription = stripHtml(item?.description || "");
                  const shortDescription =
                    plainDescription.length > 80
                      ? `${plainDescription.substring(0, 80)}...`
                      : plainDescription;

                  const authorName = getAuthorName(item);

                  return (
                    <article key={item.id} className="courseCard">
                      <Link
                        to={`/courses/${item.id}`}
                        className="courseCard__imageWrap"
                      >
                        <img
                          className="courseCard__image"
                          src={item?.cover || noIMG}
                          alt={item?.title || "course cover"}
                          onError={(event) => {
                            event.target.onerror = null;
                            event.target.src = noFile;
                          }}
                        />
                        <span className="courseCard__badge">{badgeText}</span>
                      </Link>

                      <div className="courseCard__body">
                        <h3 className="courseCard__title">
                          {item?.title || "Course title"}
                        </h3>

                        <p className="courseCard__desc">
                          {shortDescription || "Тайлбар байхгүй"}
                        </p>

                        <div className="courseCard__author">
                          <div className="courseCard__authorAvatar">
                            {authorName.charAt(0).toUpperCase()}
                          </div>

                          <div className="courseCard__authorInfo">
                            <strong>{authorName}</strong>
                            <span>Админ</span>
                          </div>
                        </div>

                        <div className="courseCard__meta">
                          <div className="courseCard__metaLeft">
                            <span>◔ {formatLessons(item)}</span>
                            <span>◷ {formatDuration(item)}</span>
                          </div>

                          <div className="courseCard__metaRight">
                            <div className="courseCard__avatars">
                              <span />
                              <span />
                              <span />
                            </div>
                            <strong>{formatStudents(item)}</strong>
                          </div>
                        </div>

                        <div className="courseCard__footer">
                          <Link
                            to={`/courses/${item.id}`}
                            className="courseCard__btn"
                          >
                            Курс үзэх
                          </Link>
                        </div>
                      </div>
                    </article>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        {/* <div className="announcementBar">
          <div className="announcementBar__content">
            📢 Хичээл IV/11-нд эхэлнэ | Виртуал менежер бэлтгэх хөтөлбөр бүртгэл
            нээлттэй 🚀
          </div>

          <button className="announcementBar__close">✕</button>
        </div> */}
      </div>
    </section>
  );
};

export default CourseList;
